// External libraries
import styled from '@emotion/styled';
import {
  BodyText as PPBodyText,
  HeadingText as PPHeadingText,
} from '@paypalcorp/pp-react-text-weasley-v7';

// Internal modules
import {
  bodyLgMediumStyles,
  bodyLgStyles,
  HIGH_CONTRAST_TEXT_COLOR,
  titleLgStyles,
} from '@/styles';
interface GetStylesParams {
  fontSize?: string;
  fontWeight?: number;
}
interface SectionHeadingProps extends GetStylesParams {
  lineHeight?: number;
  marginBottom?: string;
  marginTop?: string;
  textAlign?: string;
}

export const HeadingText = styled(PPHeadingText)<{ showTabs: boolean }>`
  margin: ${({ showTabs }) => (showTabs ? '1.5rem 0 1rem' : '0 0 1rem')};

  .overrides-font-4-2 & {
    ${titleLgStyles}
  }
`;

export const BodyText = styled(PPBodyText)`
  margin: 0 0 1.5rem;

  .overrides-font-4-2 & {
    ${bodyLgStyles}
  }
`;

export const SectionHeading = styled.h1<SectionHeadingProps>`
  color: ${({ theme }) => theme.typography.headingH1.color};
  font-size: ${({ fontSize }) => fontSize || '28px'};
  font-style: normal;
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  line-height: ${({ lineHeight = 1.33 }) => lineHeight};
  margin-bottom: ${({ marginBottom }) => marginBottom || '12px'};
  margin-top: ${({ marginTop }) => marginTop};
  text-align: ${({ textAlign }) => textAlign};

  @media (min-width: 365px) {
    font-size: ${({ fontSize }) => fontSize || '28px'};
  }

  .overrides-font-4-2 & {
    ${titleLgStyles}
  }
`;

export const SectionHeadingLarge = styled.h2`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 7px;

  .overrides-font-4-2 & {
    ${bodyLgMediumStyles}
  }
`;

interface SectionSubHeadingProps extends SectionHeadingProps {
  color?: string;
  fontWeight?: number;
}

export const SectionSubHeading = styled.h2<SectionSubHeadingProps>`
  color: ${({ color }) => color || HIGH_CONTRAST_TEXT_COLOR};
  font-size: ${({ fontSize }) => fontSize || '18px'};
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  line-height: ${({ lineHeight }) => lineHeight || 1.4};
  margin-bottom: ${({ marginBottom }) => marginBottom || '18px'};
  margin-top: ${({ marginTop }) => marginTop};
  text-align: ${({ textAlign }) => textAlign};

  a {
    margin-left: 3px;
    font-weight: ${({ fontWeight }) => fontWeight};
  }
`;
